import { COLORS } from '@/app/constants';
import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;

  @media ${media.mobile} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Item = styled.div<{ isDarkmode: boolean }>`
  position: relative;
  height: 240px;
  overflow: hidden;

  flex: 1;

  padding: 32px 36px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: ${({ isDarkmode }) =>
    isDarkmode
      ? 'linear-gradient(101.11deg, #191A19 10.04%, #301409 154.01%), #191A19'
      : 'linear-gradient(101.11deg, #F6EDEA 10.04%, #FFC3AA 154.01%)'};
`;

export const ItemImage = styled.div<{ src: string }>`
  position: absolute;
  top: 54px;
  right: 26px;
  width: 212px;
  height: 212px;
  object-fit: cover;
  opacity: 0.3;

  mask-image: url(${({ src }) => src});
  mask-size: cover;
  mask-repeat: no-repeat;

  background: linear-gradient(rgba(233, 96, 53, 1)), url(${({ src }) => src});
  background-size: cover, cover;
  background-blend-mode: hard-light;
`;

export const ItemTag = styled.div<{ isDarkmode: boolean }>`
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? `rgba(51,51,51,1)` : `rgba(239,214,200,1)`};
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 500;
  width: fit-content;

  @media ${media.mobile} {
    font-size: 12px;
  }
`;

export const ItemTitle = styled.div`
  font-size: 24px;
  font-weight: 500;

  @media ${media.mobile} {
    font-size: 16px;
  }
`;

export const ItemPool = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: rgba(248, 121, 67, 1);

  @media ${media.mobile} {
    font-size: 22px;
  }
`;

export const ItemButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;

  color: rgba(255, 92, 23, 1);
  font-size: 16px;
  font-weight: 500;
  font-family: 'Pretendard';

  transition: all 0.2s ease;

  &:hover {
    color: #e65214;
    gap: 8px;
  }

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const FriendContainer = styled.div<{ isDarkmode: boolean }>`
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? `rgba(25,26,25,1)` : `rgba(246,237,234,1)`};
  border-radius: 8px;
  padding: 40px 36px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
`;

export const FriendTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  font-size: 30px;
  font-weight: 700;

  @media ${media.mobile} {
    font-size: 20px;
  }
`;

export const FriendTitle = styled.div`
  color: rgba(248, 121, 67, 1);
`;

export const FriendContentContainer = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media ${media.mobile} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const FriendContentItem = styled.div<{ isDarkmode: boolean }>`
  position: relative;
  height: 274px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${({ isDarkmode }) =>
    isDarkmode ? `rgba(31,31,31,1)` : `rgba(243,226,221,1)`};
  border-radius: 8px;

  @media ${media.mobile} {
    height: 84px;
  }
`;

export const FriendItemIndex = styled.div<{ isDarkmode: boolean }>`
  position: absolute;
  width: 42px;
  height: 42px;
  border-radius: 50%;

  top: -21px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(248, 121, 67, 1);
  color: ${COLORS.white};
  font-size: 18px;
  font-weight: 700;

  filter: ${({ isDarkmode }) =>
    isDarkmode
      ? `drop-shadow(0px 0px 4px rgba(255, 255, 255, 0.4))`
      : `drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.2))`};

  @media ${media.mobile} {
    font-size: 14px;
    width: 28px;
    height: 28px;
    top: -14px;
  }
`;

export const FriendTextBox = styled.div<{ width: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;

  width: 100%;
  max-width: ${({ width }) => width};

  @media ${media.mobile} {
    font-size: 14px;
    line-height: 21px;
  }
`;

// ===== Referral Table Styles =====
export const ReferralTableContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ReferralTableTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-top: 8px;

  @media ${media.mobile} {
    font-size: 16px;
  }
`;

export const ReferralEmptyState = styled.div<{ isDarkmode: boolean }>`
  padding: 60px 40px;
  text-align: center;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(30, 30, 30, 1)' : 'rgba(250, 250, 250, 1)'};
  border-radius: 12px;
  border: 1px dashed ${({ isDarkmode }) => (isDarkmode ? '#444' : '#DDD')};

  @media ${media.mobile} {
    padding: 40px 20px;
  }
`;

export const ReferralEmptyIcon = styled.div`
  font-size: 60px;
  margin-bottom: 16px;

  @media ${media.mobile} {
    font-size: 40px;
  }
`;

export const ReferralEmptyTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;

  @media ${media.mobile} {
    font-size: 16px;
  }
`;

export const ReferralEmptyDesc = styled.div<{ isDarkmode: boolean }>`
  font-size: 16px;
  color: ${({ isDarkmode }) => (isDarkmode ? '#999' : '#666')};

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const ReferralTableWrapper = styled.div<{ isDarkmode: boolean }>`
  overflow-x: auto;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(25, 25, 25, 1)' : 'rgba(255, 255, 255, 1)'};
  border-radius: 12px;
  border: 1px solid ${({ isDarkmode }) => (isDarkmode ? '#444' : '#E0E0E0')};
`;

export const ReferralTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media ${media.mobile} {
    min-width: 800px;
  }
`;

export const ReferralTableHeader = styled.thead<{ isDarkmode: boolean }>`
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(40, 40, 40, 1)' : 'rgba(245, 245, 245, 1)'};
  border-bottom: 2px solid ${({ isDarkmode }) => (isDarkmode ? '#555' : '#DDD')};
`;

export const ReferralTableHeaderCell = styled.th`
  padding: 16px 12px;
  text-align: left;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  vertical-align: middle;

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  @media ${media.mobile} {
    padding: 12px 8px;
    font-size: 12px;
  }
`;

export const ReferralTableBody = styled.tbody``;

export const ReferralTableRow = styled.tr<{ isDarkmode: boolean; isEven: boolean }>`
  background-color: ${({ isDarkmode, isEven }) =>
    isEven
      ? isDarkmode
        ? 'rgba(30, 30, 30, 1)'
        : 'rgba(250, 250, 250, 1)'
      : isDarkmode
        ? 'rgba(35, 35, 35, 1)'
        : 'rgba(255, 255, 255, 1)'};
  border-bottom: 1px solid ${({ isDarkmode }) => (isDarkmode ? '#444' : '#E0E0E0')};
`;

export const ReferralTableCell = styled.td`
  padding: 16px 12px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  @media ${media.mobile} {
    padding: 12px 8px;
    font-size: 13px;
  }
`;

export const TierHeaderLabel = styled.div`
  margin-bottom: 0;
`;

export const TierHeaderReward = styled.div`
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
  color: rgba(255, 92, 23, 1);

  @media ${media.mobile} {
    font-size: 10px;
  }
`;

export const TierStatus = styled.div`
  font-size: 12px;
  color: #00c853;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  @media ${media.mobile} {
    font-size: 11px;
  }
`;

export const TierClaimButton = styled.button`
  padding: 8px 14px;
  background-color: rgba(255, 92, 23, 1);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.2s;
  font-family: 'Pretendard';

  &:hover {
    background-color: rgba(230, 82, 20, 1);
  }

  @media ${media.mobile} {
    padding: 6px 10px;
    font-size: 11px;
  }
`;

export const TierNotAchieved = styled.div`
  font-size: 12px;
  color: #999;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  @media ${media.mobile} {
    font-size: 11px;
  }
`;

export const TierConditionsBox = styled.div<{ isDarkmode: boolean }>`
  margin-top: 16px;
  padding: 16px;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(30, 30, 30, 1)' : 'rgba(245, 250, 255, 1)'};
  border-radius: 8px;
  border: 1px solid ${({ isDarkmode }) => (isDarkmode ? '#444' : '#DDD')};

  @media ${media.mobile} {
    padding: 12px;
  }
`;

export const TierConditionsTitle = styled.div<{ isDarkmode: boolean }>`
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 12px;
  color: ${({ isDarkmode }) => (isDarkmode ? '#FFF' : '#333')};

  @media ${media.mobile} {
    font-size: 12px;
  }
`;

export const TierConditionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TierConditionItem = styled.div<{ isDarkmode: boolean }>`
  font-size: 12px;
  color: ${({ isDarkmode }) => (isDarkmode ? '#CCC' : '#666')};
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media ${media.mobile} {
    font-size: 11px;
  }
`;

export const TierConditionLabel = styled.span`
  font-weight: 600;
  color: rgba(255, 92, 23, 1);
`;

export const TierConditionReward = styled.span`
  color: rgba(255, 92, 23, 1);
  font-weight: 600;
`;

// ===== Mission Item Styles =====
export const MissionItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const MissionItemDescColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ArrowIcon = styled.div`
  position: relative;
  top: 1px;
  display: inline-flex;
`;

// ===== Tier List Styles =====
export const TierListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TierItem = styled.div<{ isDarkmode: boolean; isMobile: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ isMobile }) => (isMobile ? '16px' : '24px')};
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(31, 31, 31, 1)' : 'rgba(243, 226, 221, 1)'};
  border-radius: 8px;
  padding: ${({ isMobile }) => (isMobile ? '20px 16px' : '24px 32px')};
`;

export const TierNumber = styled.div<{ isDarkmode: boolean; isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '36px' : '42px')};
  height: ${({ isMobile }) => (isMobile ? '36px' : '42px')};
  border-radius: 50%;
  background-color: #ff5c17;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ isMobile }) => (isMobile ? '16px' : '18px')};
  font-weight: 700;
  flex-shrink: 0;
  filter: ${({ isDarkmode }) =>
    isDarkmode
      ? 'drop-shadow(0px 0px 4px rgba(255, 255, 255, 0.4))'
      : 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.2))'};
`;

export const TierConditionText = styled.div<{ isMobile: boolean }>`
  flex: 1;
  font-size: ${({ isMobile }) => (isMobile ? '14px' : '18px')};
  font-weight: 500;
  line-height: ${({ isMobile }) => (isMobile ? '21px' : '26px')};
`;

export const HighlightText = styled.span`
  color: rgba(248, 121, 67, 1);
  font-weight: 700;
`;

export const TierRewardBadge = styled.div<{ isDarkmode: boolean; isMobile: boolean }>`
  background-color: ${({ isDarkmode }) => (isDarkmode ? '#333333' : 'rgb(241, 212, 203)')};
  color: #ff5c17;
  padding: ${({ isMobile }) => (isMobile ? '8px 12px' : '10px 16px')};
  border-radius: 8px;
  font-size: ${({ isMobile }) => (isMobile ? '13px' : '15px')};
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
`;
